import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import { useMediaPlayerControls } from './MediaPlayerContext';

interface ChatMessage {
  from: string;
  message: string;
}

interface ChatContextValue {
  messages: ChatMessage[];
  addMessage: (message: ChatMessage) => void;
}

const ChatContext = createContext<ChatContextValue | undefined>(undefined);

export const ChatProvider: React.FC<{children: ReactNode }> = ({ children }) => {
  const [messages, setMessages] = useState<ChatMessage[]>([]);

  const { updateYouTubeVideoId } = useMediaPlayerControls();

  const parseMessage = (message: string) => {
    const youtubeUrlRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = message.match(youtubeUrlRegex);
    if (match && match[1]) {
      updateYouTubeVideoId(match[1]);
    }
  };

  const addMessage = useCallback((message: ChatMessage) => {
    parseMessage(message.message);
    setMessages(prevMessages => [...prevMessages, message]);
  }, []);

  return (
    <ChatContext.Provider value={{ messages, addMessage }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};
